import { Button, Css, Tooltip, useTestIds } from "@homebound/beam";

type NoConfigurationEmptyStateProps = {
  /**
   * Renders the title-only version that sits in the "Original" panel alongside a chosen replacement.
   * Otherwise renders the full-width "get started" prompt with its description and call to action.
   */
  compact?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

export function NoConfigurationEmptyState(props: NoConfigurationEmptyStateProps) {
  const { compact = false, onClick, disabled = false } = props;
  const tid = useTestIds({}, "noConfigurationEmptyState");
  return (
    <div css={Css.df.fdc.aic.jcc.tac.w100.ba.bcGray300.br8.bgWhite.px3.py7.if(!compact).mb3.$} {...tid}>
      <img src={NO_CONFIGURATION_IMG} alt="" css={Css.w("260px").maxw100.mb3.$} />
      <span css={Css.mdSb.gray900.$} {...tid.title}>
        {compact ? "No Original Configuration" : "No configuration applied"}
      </span>
      {!compact && (
        <>
          <span css={Css.sm.gray700.mt1.mb3.$} {...tid.description}>
            Apply a configuration to get started on this project.
          </span>
          <Tooltip title="Select the configuration to apply to this structure">
            <Button label="Choose Configuration" variant="secondary" disabled={disabled} onClick={() => onClick?.()} />
          </Tooltip>
        </>
      )}
    </div>
  );
}

const NO_CONFIGURATION_IMG = "/images/cover-configuration-fallback.png";
